var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f045973c3c473ed0915b5bf4f3b5886484f427c5"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["sanity-blog@ownup"]={id:"f045973c3c473ed0915b5bf4f3b5886484f427c5"};
      